export default "__VITE_ASSET__CwPjPvWU__"